import script from "./IDMPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IDMPage.vue?vue&type=script&setup=true&lang=js"

import "./IDMPage.vue?vue&type=style&index=0&id=03e173c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e173c4"]])

export default __exports__